exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".saveblock[data-v-29545058]{grid-area:8/1/8/3;-ms-grid-columns:(minmax(0,1fr))[2];grid-template-columns:repeat(2,minmax(0,1fr));gap:26px 3.5%;display:-ms-grid;display:grid}@media only screen and (max-width:640px){.address_settings[data-v-29545058]{display:-ms-flexbox!important;display:flex!important;-ms-flex-direction:column;flex-direction:column}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-29545058","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/profile/views/general/General.vue
// module id = f99f97cb036d9221d46b
// module chunks = 45